export default function Spinner({ className = 'size-3 border-stone-300 border-t-stone-500' }) {
  return <span aria-hidden className={`inline-block animate-spin rounded-full border-2 ${className}`} />
}
